<template>
  <div>
    <div class="d-flex justify-content-end mb-3">
      <CButton color="primary" @click="fetchIssues(true)" :disabled="loading">
        <CIcon name="cil-reload" class="align-bottom mr-2" />
        <strong>Refresh Issues</strong>
      </CButton>
    </div>

    <CSpinner v-if="loading" />
    
    <div v-else>
      <ul class="issue-list">
        <li v-if="!issues.length" class="text-muted">No issues found.</li>
        <li v-for="(item, idx) in issues" :key="`rest-${item.restaurant_id}-${idx}`" class="mb-3">
          <strong>
            <router-link :to="{ name: 'RestaurantLinkedCategories', params: { restaurant_id: item.restaurant_id } }" target="_blank">
              #{{ item.restaurant_id }} — {{ item.restaurant_name }}
            </router-link>
          </strong>
          <ul class="mt-1">
            <li v-for="(dup, j) in item.duplicates" :key="`dup-${item.restaurant_id}-${dup.image_id}-${j}`">
              <div class="d-flex align-items-center">
                <CImg v-if="dup.image_url" :src="dup.image_url" class="img-thumb mr-2" />
                <span>Image #{{ dup.image_id }} used by {{ dup.categories.length }} categories</span>
              </div>
              <ul>
                <li v-for="c in dup.categories" :key="`cat-${c.id}`">#{{ c.id }} — {{ c.name }}</li>
              </ul>
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RestaurantsCategoryImageIssues',
  props: { active: { type: Boolean, default: false } },
  data() {
    return {
      loading: false,
      issues: [],
    }
  },
  watch: {
    active(val) { if (val) this.fetchIssues(); }
  },
  mounted() {
    if (this.active) this.fetchIssues();
  },
  methods: {
    async fetchIssues(force = false) {
      this.loading = true;
      try {
        const { data } = await this.$axios.get(this.$backend.ISSUE.GET, {
          params: { issue: 'restaurants-category-image-issues', force }
        });
        this.issues = data.data || [];
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.img-thumb {
  max-width: 80px;
  border-radius: 6px;
  border: 1px solid rgba(0,0,0,0.1);
}
.issue-list li {
  line-height: 1.4;
}
</style>


